/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/brickwall_medium'
export default icon
